<onboarding-container [hideForward]="true" [hideBack]="true">
  <p class="zero-text p-huge-med">{{ 'onboarding.ident.headline' | transloco }}</p>
  <p class="zero-text p-base-reg">{{ 'onboarding.ident.text' | transloco }}</p>
  <p class="zero-text p-bigger-reg">{{ 'onboarding.ident.possibilities' | transloco }}</p>
  @if (processNumber$ | async; as processNumber) {
    <div class="zero-surface grey-800 b-r-8 p-4 mb-3">
      <div class="zero-text p-bigger-med" [innerHTML]="'onboarding.ident.browser.headline' | transloco"></div>
      <div class="d-block d-md-flex justify-content-between align-items-center mt-4 gap">
        <div class="d-flex mb-3 mb-md-0 gap align-items-center">
          <web-design-system-icon name="online-ident" size="large" />
          <div>
            <div class="zero-text p-base-reg">{{ 'onboarding.ident.browser.text' | transloco }}</div>
            <div class="zero-text p-base-reg label">{{ 'onboarding.ident.browser.hint' | transloco }}</div>
          </div>
        </div>
        <web-design-system-button size="small" [href]="videoIdentUrl$ | async">{{
          'onboarding.ident.browser.btn' | transloco
        }}</web-design-system-button>
      </div>
    </div>
    <div class="zero-surface grey-800 b-r-8 p-4 mb-3">
      <div class="zero-text p-bigger-med" [innerHTML]="'onboarding.ident.e-perso.headline' | transloco"></div>
      <div class="d-block d-md-flex justify-content-between align-items-center mt-4 gap">
        <div class="d-flex mb-3 mb-md-0 gap align-items-center">
          <web-design-system-icon name="digital-ident" size="large" />
          <div>
            <div class="zero-text p-base-reg">{{ 'onboarding.ident.e-perso.text' | transloco }}</div>
            <div class="zero-text p-base-reg label">{{ 'onboarding.ident.e-perso.hint' | transloco }}</div>
          </div>
        </div>
        <web-design-system-button size="small" [href]="ePersoUrl$ | async">{{
          'onboarding.ident.e-perso.btn' | transloco
        }}</web-design-system-button>
      </div>
    </div>
    <div class="zero-surface grey-800 b-r-8 p-4 mb-3">
      <div class="zero-text p-bigger-med" [innerHTML]="'onboarding.ident.post.headline' | transloco"></div>
      <div class="d-block d-md-flex justify-content-between align-items-center mt-4 gap">
        <div class="d-flex mb-3 mb-md-0 gap align-items-center">
          <web-design-system-icon name="postman" size="large" />
          <div>
            <div class="zero-text p-base-reg">{{ 'onboarding.ident.post.text' | transloco }}</div>
            <div class="zero-text p-base-reg label">{{ 'onboarding.ident.post.hint' | transloco }}</div>
          </div>
        </div>
        <web-design-system-button size="small" [href]="postOfficeUrl$ | async">{{
          'onboarding.ident.post.btn' | transloco
        }}</web-design-system-button>
      </div>
    </div>
    <div class="zero-surface primary-900 d-flex flex-column justify-content-center align-items-center b-r-8 p-4">
      <div class="zero-text p-base-reg">{{ 'onboarding.ident.process-number' | transloco }}</div>
      <div class="pt-2">
        <web-design-system-copy-to-clipboard
          labelCssClass="zero-text p-huge-med text-decoration-none cursor-auto link"
          [iconSize]="'default'"
          [label]="processNumber"
          [hint]="'onboarding.ident.copy-hint' | transloco"
        />
      </div>
    </div>
  }
  <div class="mt-5 d-flex justify-content-center">
    <a class="zero-text link" (click)="modalService.open(kycDoneModal, { centered: true })">
      {{ 'onboarding.ident.kyc-done.link' | transloco }}
    </a>
    <ng-template #kycDoneModal let-modal>
      <web-design-system-modal (dismiss)="modal.dismiss('Cross click')" [headline]="'onboarding.ident.kyc-done.modal.headline' | transloco">
        <p [innerHTML]="'onboarding.ident.kyc-done.modal.text' | transloco"></p>
      </web-design-system-modal>
    </ng-template>
  </div>
</onboarding-container>
